import { api } from "../api";

export interface LoginInput {
  email: string;
  password: string;
}

export interface RegisterInput {
  name: string;
  email: string;
  password: string;
}

export interface UserAuthResponse {
  id?: string;
  name?: string;
  email?: string;
  iat?: number;
  exp?: number;
  accessToken?: string;
  refreshToken?: string;
}

export interface UserDto {
  id: string;
  name: string;
  email: string;
}

export interface RecoverPassword {
  email: string;
  password: string;
}

export type UserAuthResponseOrNull = UserAuthResponse | null;

export const login = async (params: LoginInput) => {
  const response = await api.post("/api/v1/auth/login", params);
  return response;
};

export const register = async (params: RegisterInput) => {
  const response = await api.post("/api/v1/auth/register", params);
  return response;
};

export const profile = async () => {
  const response = await api.get<UserDto>("/api/v1/customers/profile");
  return response;
};

export const registerNewPassword = async (params: RecoverPassword) => {
  const response = await api.put(
    `/api/v1/recover/${params.email}`,
    params
  );
  return response;
};
